import type {
    CreateProspectoKanbanCardRequest,
    ProspectoKanbanCardDTO,
    ProspectoKanbanCardStatus,
} from '../../../model/kartera-api-model'
import { statusKey } from '../../customers/common/customer-common'

export {
    errorMessage,
    formatActivityDate,
    formatCount,
    isMoral,
    labelize,
    money,
    personName,
    RamoMark,
    statusKey,
} from '../../customers/common/customer-common'
export { formatCompactDate, selectMenu } from '../../policies/common/policy-common'
export { PROSPECTS_PATH } from '../../prospects/common/prospect-common'

export const PIPELINE_PATH = '/prospeccion'
export const DEFAULT_BOARD_NAME = 'Embudo de ventas'
export const COLUMN_NAME_MAX = 30
export const NOMBRE_MAX = 50
export const DESCRIPCION_MAX = 1500
export const NOTA_MAX = 1500

export const OPPORTUNITY_STATUS: Array<{ id: ProspectoKanbanCardStatus; label: string; className: string }> = [
    { id: 'abierta', label: 'Abierta', className: 'bg-k-line text-k-ink-2' },
    { id: 'exitosa', label: 'Ganada', className: 'bg-k-ok-soft text-k-ok' },
    { id: 'no_exitosa', label: 'Perdida', className: 'bg-k-danger-soft text-k-danger-ink' },
]

export const opportunityStatusView = (status?: string | null) =>
    OPPORTUNITY_STATUS.find((item) => item.id === statusKey(status)) || OPPORTUNITY_STATUS[0]

/** `GET /prospectos/kanbans/{id}` espera los nombres del enum en mayúsculas. */
export const statusQuery = (showClosed: boolean) =>
    (showClosed ? ['abierta', 'exitosa', 'no_exitosa'] : ['abierta']).map((status) => status.toUpperCase()).join(',')

export const isVisibleStatus = (status: string | null | undefined, showClosed: boolean) => showClosed || statusKey(status) === 'abierta'

export const byOrden = <T extends { orden: number | null }>(items?: T[] | null): T[] =>
    [...(items || [])].sort((left, right) => Number(left.orden ?? 0) - Number(right.orden ?? 0))

/** Request de actualización a partir de la tarjeta tal como la devuelve el API. */
export const cardRequest = (
    card: ProspectoKanbanCardDTO,
    overrides: Partial<CreateProspectoKanbanCardRequest> = {},
): CreateProspectoKanbanCardRequest => ({
    id: card.id,
    columnId: Number(card.columnId),
    nombre: card.nombre || '',
    prospectoId: Number(card.prospecto?.id),
    descripcion: card.descripcion || '',
    primaTotal: Number(card.primaTotal || 0),
    ramoId: Number(card.ramo?.id),
    moneda: card.moneda?.abreviacion || 'MXN',
    status: card.status || 'abierta',
    orden: null,
    ...overrides,
})
